<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <Form 
      pageType="Edit"
      :onSubmit="onSubmit"
      :alertType="this.alertType"
      :alertMessage="this.alertMessage"
      :clientProps="client"
      />
    </div>
  </div>

</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/clients/Form.vue";
import ClientDataService from "@/services/ClientDataService";

export default {
  setup(){
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("client", "Client Management", "/admin/client")
    return {
      appStore
    }
  },
  created(){
    this.getClient()
  },
  data(){
    return {
      alertType: '',
      alertMessage: '',
      client: {
          id: null,
          clientName: "",
          authToken: ""
        }
    }
  },
  components: {
    Form
  },
  methods: {
    getClient(){
      ClientDataService.get(this.$route.params.id)
        .then(response => {
          console.log(response)
        })
        .catch(e => {
          console.log(e )
        });
    },
    onSubmit(client) {
      var data = {
        client_name: client.clientName,
        auth_token: client.authToken          
      };
      
      ClientDataService.update(this.$route.params.id, data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Client successfuly Updated'
          this.$router.replace('/admin/clients')
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          console.log(e);
        });
    }
  }
};
</script>
